import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from "react-redux";


import '@scuf/common/honeywell-dark/theme.css'
import { Grid, SidebarLayout, Footer, Header, Input, Icon, Button, toggleTheme, ThemeType } from '@scuf/common';
import '@scuf/dashboard/honeywell-dark/theme.css'
import '@scuf/charts/honeywell-compact-dark/theme.css'
import { types } from '../../types/types';
import UseChatMessage from '../../customHook/useChatMessage';

class LayoutPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarCollapsed: true,
      settingsCollapsed: true,
      logged: false,
      isDark: true,
      activeName: '',
      logoCompany: '../../assets/codelco_logo.png'
    }

    this.handleItemClick = this.handleItemClick.bind(this);

  }



  componentDidMount() {
    var isDark = JSON.parse(localStorage.getItem('isDark'));

    this.changeLogo(isDark);
  }

  onCollapsedClick() {
    this.setState((prevState) => ({ sidebarCollapsed: !prevState.sidebarCollapsed }));
  }

  onSettingsCollapsedClick() {
    this.setState((prevState) => ({ settingsCollapsed: !prevState.settingsCollapsed }));
  }

  changeLogo(dark) {
    if (dark) {
      toggleTheme(ThemeType.Dark);
      this.setState({
        logoCompany: '../../assets/codelco_logo.png',
        isDark: !this.state.isDark
      })
    } else {
      if (dark) {
        toggleTheme(ThemeType.Light);
        this.setState({
          logoCompany: '../../assets/codelco_logo.png',
          isDark: !this.state.isDark
        })
      }
    }
  }

  changeLogoDark() {

    if (this.state.isDark) {
      toggleTheme(ThemeType.Dark);
      this.setState({
        logoCompany: '../../assets/codelco_logo.png',
        isDark: false
      })
    } else {
      toggleTheme(ThemeType.Light);
      this.setState({
        logoCompany: '../../assets/codelco_logo.png',
        isDark: true
      })

    }

    localStorage.setItem('isDark', this.state.isDark);

  }



  listTop() {
    var list = [];
    return list;
  }

  ItemMenuHorizontal({ title: title, icon: icon, link: link }) {

    return <div className='item-menu'>
      <Icon root='common' name={icon} exactSize={22}></Icon>
      <div style={{ textAlign: 'center' }}>{title}</div>
    </div>;
  };

  iconText({ text: text, icon: icon }) {
    return <div style={{ textAlign: 'center', marginBottom: '10px' }}>
      {icon}
      <div className='label-menu'>{text}</div>
    </div>;
  }

  handleItemClick(name) {
    //    this.setState({ activeName: name });
    this.props.setSelectedPage(name);
    this.props.history.push(name);
  }

  closeLogin() {
    localStorage.removeItem('user');
    this.props.history.push('/login');
  }

  closeSalir() {
    localStorage.removeItem('user');
    this.props.history.push('/');
  }


  render() {
    const { sidebarCollapsed, settingsCollapsed, name, email, message, logged, logoCompany, activeName } = this.state;

    var user = JSON.parse(localStorage.getItem('user'));
    return (
      <>

        <Header isForge={true} title={null} onMenuToggle={(open) => this.setState({ sidebarCollapsed: !open })}>
          <Header.Item style={{ padding: '0px' }}>
            <div
              onClick={x => this.changeLogoDark()}
              style={{
                fontSize:'20px',
                marginTop:'0px',
                 textAlign:'center'
                 }}>  
              {this.state.isDark == true ? <i className="fas fa-sun"></i> : <i className="fas fa-sun"></i>}
            </div>
          </Header.Item>
          <Header.UserProfile firstName={user.data ? user.data.Username[0] : ''} lastName={user.data ? user.data.Username[1] : ''} role="Admin">
            {/*user.data.isAdmin ?
              <Header.UserProfile.Item>
              <Link to="/changePassword">
                <div className='menu-header'>Cambiar clave</div>
              </Link>
            </Header.UserProfile.Item>
            : <></>*/}
            <Header.UserProfile.Item>
              {user.data.isAdmin ?
              <a  onClick={() => this.closeLogin()}>
                <div className='menu-header'>Cerrar sesión</div>
              </a> :
              <a  onClick={() => this.closeSalir()}>
              <div className='menu-header'>Salir</div>
            </a>
            }
            </Header.UserProfile.Item>
          </Header.UserProfile>
        </Header>
        { user.data.isAdmin ?
        <div className='horizonta-menu' style={{ position: 'fixed', background: this.state.isDark ? 'black' : '#f1f0f0' }}>
          <div className={this.props.sharingReducer.selectedPage == '/admin' ? 'item-menu-link p-50 item-menu-active' : 'item-menu-link p-50 item-menu-inactive'}
            onClick={() => this.handleItemClick('/admin')} >
            {this.ItemMenuHorizontal({
              title: 'Home', icon: 'home',

            })}
          </div>

          <div className={this.props.sharingReducer.selectedPage == '/dashboard' ? 'item-menu-link p-50 item-menu-active' : 'item-menu-link p-50 item-menu-inactive'}
            onClick={() => this.handleItemClick('/dashboard')} >
            {this.ItemMenuHorizontal({
              title: 'Dashboard', icon: 'pie-chart',

            })}
          </div>
        </div>
        : <div></div>  
      }
        <SidebarLayout collapsed={sidebarCollapsed} className="example-sidebar">
        { user.data.isAdmin ?
          <SidebarLayout.Sidebar>
          <SidebarLayout.Sidebar.Item content="Detail"
              activeName={this.props.sharingReducer.selectedPage}
              onClick={() => this.handleItemClick('/admin')}
              active={this.props.sharingReducer.selectedPage == '/admin' ? true : false}
              icon={
                this.iconText({
                  text: 'Home',
                  icon: <Icon root='common' name='home'></Icon>
                })}
            />
          <SidebarLayout.Sidebar.Item content="Detail"
              activeName={this.props.sharingReducer.selectedPage}
              onClick={() => this.handleItemClick('/dashboard')}
              active={this.props.sharingReducer.selectedPage == '/dashboard' ? true : false}
              icon={
                this.iconText({
                  text: 'Dashboard',
                  icon: <Icon root='common' name='pie-chart'></Icon>
                })}
            />


          </SidebarLayout.Sidebar>
          :<></>
        }
          <SidebarLayout.Content>
            <div className='content-component'>
              {this.props.component}
            </div>
          </SidebarLayout.Content>
        </SidebarLayout>
        { 
        /*
          <Footer className='no-show-movil' >
            <Footer.Item href="#">Terms & Conditions</Footer.Item>
            <Footer.Item href="#">Privacy Policy</Footer.Item>
          </Footer>
        */
        }

      </>
    );
  }
}


const mapStateToProps = state => ({
  sharingReducer: state.sharingReducer
})
const mapDispatchTopProps = dispatch => ({

  setSelectedPage(payload) {
    dispatch({
      type: types.selectedPage,
      payload
    })
  }
  
});
//export default withRouter(LayoutPage);
export default connect(mapStateToProps, mapDispatchTopProps)(withRouter(LayoutPage));